import { connect } from 'react-redux'

import { checkNewPicoUserRegistered } from '../module/sagas/lifecycleEvents/pico.user.registered'
import { checkPaymentMethodAdded } from '../module/sagas/lifecycleEvents/pico.paymentMethod.added'

const newPicoUserRegisteredEventCheck = checkNewPicoUserRegistered()
const paymentMethodAddedEventCheck = checkPaymentMethodAdded()

const LifecycleEvents = ({ children }) => children

const mapStateToProps = (state) => ({
    ...state,
})

const mapDispatchToProps = (dispatch) => ({
    dispatch,
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { dispatch } = dispatchProps
    newPicoUserRegisteredEventCheck({ state: stateProps, dispatch })
    paymentMethodAddedEventCheck({ state: stateProps, dispatch })
    return ownProps
}
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(LifecycleEvents)
